module.exports = __webpack_public_path__ + "static/iphonex-ab6240eab58cbead12bc35855ff68484.jpg";